var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deploying"},[_c('span',{staticClass:"upperContent"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t(("Onboarding.licenseStage." + _vm.stage)))+" "),_c('span',{staticClass:"dot"},[_vm._v(".")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }